import { render, staticRenderFns } from "./PacketSelect.vue?vue&type=template&id=0f84d7dd&lang=pug&"
import script from "./PacketSelect.vue?vue&type=script&lang=js&"
export * from "./PacketSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports